export const customTableFr = {
  emptyMessage: 'Aucune donnée',
  loading: 'Chargement...',
};
